export enum ConversationType {
  DatabaseCell = 'database-cell',
  DatabaseFile = 'database-file',
  CloudFile = 'cloud-file',
  Workspace = 'workspace',
  Direct = 'direct',
  CallRoom = 'call-room',
  // Group = 'group',
}
